import { render, staticRenderFns } from "./LabSolubilityIodate.vue?vue&type=template&id=25812eb4&"
import script from "./LabSolubilityIodate.vue?vue&type=script&lang=ts&"
export * from "./LabSolubilityIodate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports